import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { CommentIcon } from "../../../assets/image/CommentIcon";
import { ListIcon } from "../../../assets/image/ListIcon";
import { PageListIcon } from "../../../assets/image/PageListIcon";
import { StarRoundIcon } from "../../../assets/image/StarRoundIcon";
import { GiftIcon } from "../../../assets/image/GiftIcon";
import { ConfirmArrowIcon } from "../../../assets/image/ConfirmArrowIcon";
import {useNotification} from "../../Notifications/NotificationsContext";

export function NotificationTabProvider(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
    const { notificationData } = useNotification();
  
  return (
    <>
      <ul>
        <li
          className={props.subtab == "interview-invite" ? "active" : ""}
          onClick={(e) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            props.setsubtab("interview-invite");
            navigate("/search-providers/interview-invite");
          }}
        >
          <CommentIcon />
          {t("interview-invites")} ({notificationData.invitation})
        </li>
        <li
          className={props.subtab == "new-recommendation" ? "active" : ""}
          onClick={(e) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            props.setsubtab("new-recommendation");
            navigate("/search-providers/new-recommendation");
          }}
        >
           <ListIcon />
          {t("new-recommendations")} ({notificationData.recommendation})
        </li>
        <li
          className={props.subtab == "document-request" ? "active" : ""}
          onClick={(e) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            props.setsubtab("document-request");
            navigate("/search-providers/document-request");
          }}
        >
          <PageListIcon />
          {t("document-requests")} ({notificationData.documentrequest})
        </li>
        <li
          className={props.subtab == "hirings" ? "active" : ""}
          onClick={(e) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            props.setsubtab("hirings");
            navigate("/search-providers/hirings");
          }}
        >
          <ConfirmArrowIcon />
          {t("new-hirings")} ({notificationData.hiring})
        </li>
        <li
          className={props.subtab == "new-reviews" ? "active" : ""}
          onClick={(e) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            props.setsubtab("new-reviews");
            navigate("/search-providers/new-reviews");
          }}
        >
          <StarRoundIcon />
          {t("new-reviews")} ({notificationData.review})
        </li>
        <li
          className={props.subtab == "Loyalty-notification" ? "active" : ""}
          onClick={(e) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            props.setsubtab("Loyalty-notification");
            navigate("/search-providers/Loyalty-notification");
          }}
        >
          <GiftIcon color={"#636363"} />
          {t("senscare-loyalty")} ({notificationData.loyalty})
        </li>
      </ul>
    </>
  );
}